module.exports = __webpack_public_path__ + "img/fr.98a7a6f2.svg";